// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.full-height {
  height: calc(100vh - 90px);
}

p {
  margin: 0;
  padding: 0;
}

.bounceInRight {
  -webkit-animation-name: bounceInRight;
  animation-name: bounceInRight;
}

.custom-loader {
  position: relative;
  height: 100%;
  width: 100%;
  pointer-events: none;
  display: flex;
  justify-content: center;
  align-items: center;
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 10;
}

.icon-filled {
  font-variation-settings: "FILL" 1, "wght" 400, "GRAD" 0, "opsz" 48;
}

.no-pointer {
  cursor: not-allowed !important;
}

.zoom-join-button-text {
  font-family: "Semi Sans", sans-serif;
  font-style: normal;
  font-weight: 600;
  cursor: pointer;
}

.Course-card-header-program-name-text {
  font-family: "Medium Sans", sans-serif;
  font-style: normal;
  font-weight: 500;
  color: #333b48;
  text-transform: capitalize;
  text-overflow: ellipsis;
  white-space: normal;
  font-size: 16px;
}

@media (max-width: 769px) {
  .Course-card-header {
    display: flex !important;
    flex-wrap: wrap !important;
  }
  .Course-card-header .Course-card-header-program-name-text {
    font-size: 14px;
  }
  .Course-card-header .course-card-img {
    width: 70px;
  }
  .Course-card-header .Course-card-header-middle-column {
    flex-grow: 1;
  }
  .Course-card-header .Course-card-header-program-name {
    max-width: auto !important;
  }
}

.d-none {
  display: none !important;
}

.d-block {
  display: block !important;
}

.d-flex {
  display: flex !important;
}

.w-100 {
  width: 100% !important;
}

.h-100 {
  height: 100% !important;
}

.vh-100 {
  height: 100vh !important;
}

.vw-100 {
  width: 100vw !important;
}

/* Flexbox Utilities */
.flex-row {
  flex-direction: row !important;
}

.flex-column {
  flex-direction: column !important;
}

.flex-row-reverse {
  flex-direction: row-reverse !important;
}

.flex-column-reverse {
  flex-direction: column-reverse !important;
}

.flex-grow-0 {
  flex-grow: 0 !important;
}

.flex-grow-1 {
  flex-grow: 1 !important;
}

.flex-shrink-0 {
  flex-shrink: 0 !important;
}

.flex-shrink-1 {
  flex-shrink: 1 !important;
}

.flex-wrap {
  flex-wrap: wrap !important;
}

.flex-nowrap {
  flex-wrap: nowrap !important;
}

.flex-wrap-reverse {
  flex-wrap: wrap-reverse !important;
}

.justify-content-start {
  justify-content: flex-start !important;
}

.justify-content-end {
  justify-content: flex-end !important;
}

.justify-content-center {
  justify-content: center !important;
}

.justify-content-between {
  justify-content: space-between !important;
}

.justify-content-around {
  justify-content: space-around !important;
}

.justify-content-evenly {
  justify-content: space-evenly !important;
}

.align-items-start {
  align-items: flex-start !important;
}

.align-items-end {
  align-items: flex-end !important;
}

.align-items-center {
  align-items: center !important;
}

.align-items-baseline {
  align-items: baseline !important;
}

.align-items-stretch {
  align-items: stretch !important;
}

.align-content-start {
  align-content: flex-start !important;
}

.align-content-end {
  align-content: flex-end !important;
}

.align-content-center {
  align-content: center !important;
}

.align-content-between {
  align-content: space-between !important;
}

.align-content-around {
  align-content: space-around !important;
}

.align-content-stretch {
  align-content: stretch !important;
}

.align-self-auto {
  align-self: auto !important;
}

.align-self-start {
  align-self: flex-start !important;
}

.align-self-end {
  align-self: flex-end !important;
}

.align-self-center {
  align-self: center !important;
}

.align-self-baseline {
  align-self: baseline !important;
}

.align-self-stretch {
  align-self: stretch !important;
}

/* Margin and Padding Utilities */
.m-0 {
  margin: 0 !important;
}

.m-1 {
  margin: 0.25rem !important;
}

.m-2 {
  margin: 0.5rem !important;
}

.m-3 {
  margin: 1rem !important;
}

.m-4 {
  margin: 1.5rem !important;
}

.m-5 {
  margin: 3rem !important;
}

.m-auto {
  margin: auto !important;
}

/* Other margin classes omitted for brevity */
.p-0 {
  padding: 0 !important;
}

.p-1 {
  padding: 0.25rem !important;
}

.p-2 {
  padding: 0.5rem !important;
}

.p-3 {
  padding: 1rem !important;
}

.p-4 {
  padding: 1.5rem !important;
}

.p-5 {
  padding: 3rem !important;
}

/* Other padding classes omitted for brevity */
/* Display Utilities */
.d-inline {
  display: inline !important;
}

.d-inline-block {
  display: inline-block !important;
}

.d-block {
  display: block !important;
}

.d-table {
  display: table !important;
}

.d-table-row {
  display: table-row !important;
}

.d-flex {
  display: flex !important;
}

.d-inline-flex {
  display: inline-flex !important;
}

.d-none {
  display: none !important;
}

.h-auto {
  height: auto !important;
}

.w-auto {
  width: auto !important;
}

p {
  margin-bottom: 1rem;
}

/* Padding Top */
.pt-0 {
  padding-top: 0 !important;
}

.pt-1 {
  padding-top: 0.25rem !important;
}

.pt-2 {
  padding-top: 0.5rem !important;
}

.pt-3 {
  padding-top: 1rem !important;
}

.pt-4 {
  padding-top: 1.5rem !important;
}

.pt-5 {
  padding-top: 3rem !important;
}

/* Padding Left */
.pl-0 {
  padding-left: 0 !important;
}

.pl-1 {
  padding-left: 0.25rem !important;
}

.pl-2 {
  padding-left: 0.5rem !important;
}

.pl-3 {
  padding-left: 1rem !important;
}

.pl-4 {
  padding-left: 1.5rem !important;
}

.pl-5 {
  padding-left: 3rem !important;
}

/* Padding Bottom */
.pb-0 {
  padding-bottom: 0 !important;
}

.pb-1 {
  padding-bottom: 0.25rem !important;
}

.pb-2 {
  padding-bottom: 0.5rem !important;
}

.pb-3 {
  padding-bottom: 1rem !important;
}

.pb-4 {
  padding-bottom: 1.5rem !important;
}

.pb-5 {
  padding-bottom: 3rem !important;
}

/* Padding Right */
.pr-0 {
  padding-right: 0 !important;
}

.pr-1 {
  padding-right: 0.25rem !important;
}

.pr-2 {
  padding-right: 0.5rem !important;
}

.pr-3 {
  padding-right: 1rem !important;
}

.pr-4 {
  padding-right: 1.5rem !important;
}

.pr-5 {
  padding-right: 3rem !important;
}

/* Margin Top */
.mt-0 {
  margin-top: 0 !important;
}

.mt-1 {
  margin-top: 0.25rem !important;
}

.mt-2 {
  margin-top: 0.5rem !important;
}

.mt-3 {
  margin-top: 1rem !important;
}

.mt-4 {
  margin-top: 1.5rem !important;
}

.mt-5 {
  margin-top: 3rem !important;
}

/* Margin Bottom */
.mb-0 {
  margin-bottom: 0 !important;
}

.mb-1 {
  margin-bottom: 0.25rem !important;
}

.mb-2 {
  margin-bottom: 0.5rem !important;
}

.mb-3 {
  margin-bottom: 1rem !important;
}

.mb-4 {
  margin-bottom: 1.5rem !important;
}

.mb-5 {
  margin-bottom: 3rem !important;
}

/* Margin Left */
.ml-0 {
  margin-left: 0 !important;
}

.ml-1 {
  margin-left: 0.25rem !important;
}

.ml-2 {
  margin-left: 0.5rem !important;
}

.ml-3 {
  margin-left: 1rem !important;
}

.ml-4 {
  margin-left: 1.5rem !important;
}

.ml-5 {
  margin-left: 3rem !important;
}

/* Margin Right */
.mr-0 {
  margin-right: 0 !important;
}

.mr-1 {
  margin-right: 0.25rem !important;
}

.mr-2 {
  margin-right: 0.5rem !important;
}

.mr-3 {
  margin-right: 1rem !important;
}

.mr-4 {
  margin-right: 1.5rem !important;
}

.mr-5 {
  margin-right: 3rem !important;
}

h1 {
  margin-top: 0;
  margin-bottom: 0.5rem;
  font-weight: 500;
  line-height: 1.2;
}

h2 {
  margin-top: 0;
  margin-bottom: 0.5rem;
  font-weight: 500;
  line-height: 1.2;
}

h3 {
  margin-top: 0;
  margin-bottom: 0.5rem;
  font-weight: 500;
  line-height: 1.2;
}

h4 {
  margin-top: 0;
  margin-bottom: 0.5rem;
  font-weight: 500;
  line-height: 1.2;
}

h5 {
  margin-top: 0;
  margin-bottom: 0.5rem;
  font-weight: 500;
  line-height: 1.2;
}

h6 {
  margin-top: 0;
  margin-bottom: 0.5rem;
  font-weight: 500;
  line-height: 1.2;
}

p {
  margin: 0;
  padding: 0;
}

.slick-dots .slick-active .customDots {
  width: 28px !important;
  background: #5095fc !important;
}

.slick-dots {
  bottom: -16px !important;
}
.slick-dots li {
  margin: 0 8px !important;
  width: fit-content !important;
  height: fit-content !important;
}
.slick-dots li:first-child {
  margin-right: 0px !important;
}

.zoom-mobile-view {
  height: 100vh;
  width: 100vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background: linear-gradient(249deg, #c2d5ff 26%, #d7fff8 73.92%);
}
.zoom-mobile-view-img {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 16px;
}

.zoom-trying-img {
  width: 100%;
}
@supports (-webkit-touch-callout: none) {
  .zoom-trying-img {
    height: calc(100vh - 450px);
    object-fit: contain;
  }
}
.zoom-trying-img {
  height: calc(100vh - 420px);
}
@media screen and (min-height: 730px) {
  .zoom-trying-img {
    height: 45vh;
    padding-top: 60px;
  }
}
@media screen and (min-height: 850px) {
  .zoom-trying-img {
    height: 45vh;
    padding-top: 80px;
  }
}

.zoom-mobile-img {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
}
.zoom-mobile-img .zoom-background-img {
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-position: top;
  background-size: cover;
}

.zoom-mobile-bottom-container {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  height: 320px;
  width: 100vw;
}
@media screen and (min-height: 820px) {
  .zoom-mobile-bottom-container {
    height: 42vh;
  }
}
.zoom-mobile-bottom-container {
  padding: 28px 16px 24px 16px;
  gap: 24px;
  background-color: white;
  border-radius: 30px 30px 0px 0px;
  border: 2px solid var(--Color-Surface-Primary, #fdfdfd);
  background: #f0f4ff;
  box-shadow: 0px -4px 16px 0px rgba(147, 172, 214, 0.3);
}
.zoom-mobile-bottom-container p {
  margin: 0;
  padding: 0;
}
.zoom-mobile-bottom-container .zoom-mobile-heading {
  color: #5095fc;
  font-size: 20px;
  font-family: "Semi Sans", sans-serif;
  font-style: normal;
  font-weight: 600;
  line-height: 125%;
  width: 100%;
  text-align: center;
}
.zoom-mobile-bottom-container .zoom-mobile-subHeading {
  color: #000;
  text-align: center;
  font-size: 14px;
  line-height: 150%;
  margin-top: 12px;
  font-family: "Regular Sans", sans-serif;
  font-style: normal;
  color: var(--Color-Text-Primary, #333b48);
  text-align: center;
}
.zoom-mobile-bottom-container .app-store-button {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
  gap: 16px;
}
.zoom-mobile-bottom-container .app-store-button img {
  width: 167px;
}
@media (max-width: 375px) {
  .zoom-mobile-bottom-container .app-store-button img {
    width: 40vw;
  }
}
.zoom-mobile-bottom-container .continue-browser {
  color: rgba(0, 0, 0, 0.6);
  text-align: center;
  font-family: "Roboto";
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  text-decoration-line: underline;
  cursor: pointer;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
}
.zoom-mobile-bottom-container .or-button {
  color: rgba(0, 0, 0, 0.5);
  text-align: center;
  font-family: "Roboto";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 18px */
}

.left-short-img {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.left-short-img .left-short-img-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 24px;
  padding: 0 40px;
}
.left-short-img .left-short-img-container .app-store-button {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 16px;
  flex-wrap: wrap;
}
.left-short-img .left-short-img-container .app-store-button img {
  width: 160px;
  height: 52px;
}
.left-short-img img {
  width: 192px;
  height: 34px;
}
.left-short-img h6 {
  color: var(--Color-Accent-Shade-1, #5095fc);
  font-family: "Semi Sans", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 32px;
  line-height: 125%;
  margin: 0;
}
.left-short-img p {
  margin: 0;
  margin-top: 12px;
  color: var(--Color-Text-Primary, #333b48);
  font-family: "Regular Sans", sans-serif;
  font-style: normal;
  font-size: 18px;
  line-height: 150%;
}
@media (max-width: 765px) {
  .left-short-img h6 {
    font-size: 24px;
  }
  .left-short-img p {
    font-size: 16px;
  }
}`, "",{"version":3,"sources":["webpack://./src/scss/globals.scss","webpack://./src/scss/_mixins.scss"],"names":[],"mappings":"AAEA;EACE,mCAAA;EACA,kCAAA;AADF;;AAGA;EACE,0BAAA;AAAF;;AAEA;EACE,SAAA;EACA,UAAA;AACF;;AAKA;EACE,qCAAA;EACA,6BAAA;AAFF;;AAIA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,oBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AADF;;AAGA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,WAAA;AAAF;;AAEA;EACE,kEAAA;AACF;;AACA;EACE,8BAAA;AAEF;;AAAA;ECHE,oCAAA;EACA,kBAAA;EACA,gBAAA;EDGA,eAAA;AAKF;;AAHA;ECZE,sCAAA;EACA,kBAAA;EACA,gBAAA;EDYA,cAAA;EACA,0BAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AAQF;;AALE;EADF;IAEI,wBAAA;IACA,0BAAA;EASF;EARE;IACE,eAAA;EAUJ;EARE;IACE,WAAA;EAUJ;EAPE;IACE,YAAA;EASJ;EAPE;IACE,0BAAA;EASJ;AACF;;AANA;EACE,wBAAA;AASF;;AAPA;EACE,yBAAA;AAUF;;AARA;EACE,wBAAA;AAWF;;AATA;EACE,sBAAA;AAYF;;AAVA;EACE,uBAAA;AAaF;;AAXA;EACE,wBAAA;AAcF;;AAZA;EACE,uBAAA;AAeF;;AAZA,sBAAA;AACA;EACE,8BAAA;AAeF;;AAbA;EACE,iCAAA;AAgBF;;AAdA;EACE,sCAAA;AAiBF;;AAfA;EACE,yCAAA;AAkBF;;AAhBA;EACE,uBAAA;AAmBF;;AAjBA;EACE,uBAAA;AAoBF;;AAlBA;EACE,yBAAA;AAqBF;;AAnBA;EACE,yBAAA;AAsBF;;AApBA;EACE,0BAAA;AAuBF;;AArBA;EACE,4BAAA;AAwBF;;AAtBA;EACE,kCAAA;AAyBF;;AAvBA;EACE,sCAAA;AA0BF;;AAxBA;EACE,oCAAA;AA2BF;;AAzBA;EACE,kCAAA;AA4BF;;AA1BA;EACE,yCAAA;AA6BF;;AA3BA;EACE,wCAAA;AA8BF;;AA5BA;EACE,wCAAA;AA+BF;;AA7BA;EACE,kCAAA;AAgCF;;AA9BA;EACE,gCAAA;AAiCF;;AA/BA;EACE,8BAAA;AAkCF;;AAhCA;EACE,gCAAA;AAmCF;;AAjCA;EACE,+BAAA;AAoCF;;AAlCA;EACE,oCAAA;AAqCF;;AAnCA;EACE,kCAAA;AAsCF;;AApCA;EACE,gCAAA;AAuCF;;AArCA;EACE,uCAAA;AAwCF;;AAtCA;EACE,sCAAA;AAyCF;;AAvCA;EACE,iCAAA;AA0CF;;AAxCA;EACE,2BAAA;AA2CF;;AAzCA;EACE,iCAAA;AA4CF;;AA1CA;EACE,+BAAA;AA6CF;;AA3CA;EACE,6BAAA;AA8CF;;AA5CA;EACE,+BAAA;AA+CF;;AA7CA;EACE,8BAAA;AAgDF;;AA7CA,iCAAA;AACA;EACE,oBAAA;AAgDF;;AA9CA;EACE,0BAAA;AAiDF;;AA/CA;EACE,yBAAA;AAkDF;;AAhDA;EACE,uBAAA;AAmDF;;AAjDA;EACE,yBAAA;AAoDF;;AAlDA;EACE,uBAAA;AAqDF;;AAnDA;EACE,uBAAA;AAsDF;;AApDA,6CAAA;AAEA;EACE,qBAAA;AAsDF;;AApDA;EACE,2BAAA;AAuDF;;AArDA;EACE,0BAAA;AAwDF;;AAtDA;EACE,wBAAA;AAyDF;;AAvDA;EACE,0BAAA;AA0DF;;AAxDA;EACE,wBAAA;AA2DF;;AAzDA,8CAAA;AAEA,sBAAA;AACA;EACE,0BAAA;AA2DF;;AAzDA;EACE,gCAAA;AA4DF;;AA1DA;EACE,yBAAA;AA6DF;;AA1DA;EACE,yBAAA;AA6DF;;AA3DA;EACE,6BAAA;AA8DF;;AA5DA;EACE,wBAAA;AA+DF;;AA7DA;EACE,+BAAA;AAgEF;;AA9DA;EACE,wBAAA;AAiEF;;AA9DA;EACE,uBAAA;AAiEF;;AA/DA;EACE,sBAAA;AAkEF;;AAhEA;EACE,mBAAA;AAmEF;;AAjEA,gBAAA;AACA;EACE,yBAAA;AAoEF;;AAlEA;EACE,+BAAA;AAqEF;;AAnEA;EACE,8BAAA;AAsEF;;AApEA;EACE,4BAAA;AAuEF;;AArEA;EACE,8BAAA;AAwEF;;AAtEA;EACE,4BAAA;AAyEF;;AAtEA,iBAAA;AACA;EACE,0BAAA;AAyEF;;AAvEA;EACE,gCAAA;AA0EF;;AAxEA;EACE,+BAAA;AA2EF;;AAzEA;EACE,6BAAA;AA4EF;;AA1EA;EACE,+BAAA;AA6EF;;AA3EA;EACE,6BAAA;AA8EF;;AA3EA,mBAAA;AACA;EACE,4BAAA;AA8EF;;AA5EA;EACE,kCAAA;AA+EF;;AA7EA;EACE,iCAAA;AAgFF;;AA9EA;EACE,+BAAA;AAiFF;;AA/EA;EACE,iCAAA;AAkFF;;AAhFA;EACE,+BAAA;AAmFF;;AAhFA,kBAAA;AACA;EACE,2BAAA;AAmFF;;AAjFA;EACE,iCAAA;AAoFF;;AAlFA;EACE,gCAAA;AAqFF;;AAnFA;EACE,8BAAA;AAsFF;;AApFA;EACE,gCAAA;AAuFF;;AArFA;EACE,8BAAA;AAwFF;;AArFA,eAAA;AACA;EACE,wBAAA;AAwFF;;AAtFA;EACE,8BAAA;AAyFF;;AAvFA;EACE,6BAAA;AA0FF;;AAxFA;EACE,2BAAA;AA2FF;;AAzFA;EACE,6BAAA;AA4FF;;AA1FA;EACE,2BAAA;AA6FF;;AA1FA,kBAAA;AACA;EACE,2BAAA;AA6FF;;AA3FA;EACE,iCAAA;AA8FF;;AA5FA;EACE,gCAAA;AA+FF;;AA7FA;EACE,8BAAA;AAgGF;;AA9FA;EACE,gCAAA;AAiGF;;AA/FA;EACE,8BAAA;AAkGF;;AA/FA,gBAAA;AACA;EACE,yBAAA;AAkGF;;AAhGA;EACE,+BAAA;AAmGF;;AAjGA;EACE,8BAAA;AAoGF;;AAlGA;EACE,4BAAA;AAqGF;;AAnGA;EACE,8BAAA;AAsGF;;AApGA;EACE,4BAAA;AAuGF;;AApGA,iBAAA;AACA;EACE,0BAAA;AAuGF;;AArGA;EACE,gCAAA;AAwGF;;AAtGA;EACE,+BAAA;AAyGF;;AAvGA;EACE,6BAAA;AA0GF;;AAxGA;EACE,+BAAA;AA2GF;;AAzGA;EACE,6BAAA;AA4GF;;AAzGA;EACE,aAAA;EACA,qBAAA;EACA,gBAAA;EACA,gBAAA;AA4GF;;AAzGA;EACE,aAAA;EACA,qBAAA;EACA,gBAAA;EACA,gBAAA;AA4GF;;AAzGA;EACE,aAAA;EACA,qBAAA;EACA,gBAAA;EACA,gBAAA;AA4GF;;AAzGA;EACE,aAAA;EACA,qBAAA;EACA,gBAAA;EACA,gBAAA;AA4GF;;AAzGA;EACE,aAAA;EACA,qBAAA;EACA,gBAAA;EACA,gBAAA;AA4GF;;AAzGA;EACE,aAAA;EACA,qBAAA;EACA,gBAAA;EACA,gBAAA;AA4GF;;AA1GA;EACE,SAAA;EACA,UAAA;AA6GF;;AA1GA;EACE,sBAAA;EACA,8BAAA;AA6GF;;AA3GA;EACE,wBAAA;AA8GF;AA7GE;EACE,wBAAA;EACA,6BAAA;EACA,8BAAA;AA+GJ;AA7GE;EACE,4BAAA;AA+GJ;;AA5GA;EACE,aAAA;EACA,YAAA;ECxfA,aAAA;EACA,sBDwfc;ECvfd,mBAHyC;EAIzC,uBAJmE;ED2fnE,gBAAA;EACA,gEAAA;AAkHF;AAjHE;EC5fA,aAAA;EACA,mBAFsB;EAGtB,mBAHyC;EAIzC,uBAJmE;ED+fjE,aAAA;AAsHJ;;AAnHA;EACE,WAAA;AAsHF;AApHE;EAHF;IAII,2BAAA;IACA,mBAAA;EAuHF;AACF;AA7HA;EAOE,2BAAA;AAyHF;AAnHE;EAbF;IAcI,YAAA;IACA,iBAAA;EAsHF;AACF;AApHE;EAlBF;IAmBI,YAAA;IACA,iBAAA;EAuHF;AACF;;AApHA;EACE,YAAA;EC1hBA,aAAA;EACA,sBD0hBc;ECzhBd,mBDyhBsB;ECxhBtB,2BDwhB8B;AA0HhC;AAxHE;EACE,WAAA;EACA,YAAA;EACA,4BAAA;EACA,wBAAA;EACA,sBAAA;AA0HJ;;AAtHA;EACE,YAAA;ECviBA,aAAA;EACA,sBDuiBc;ECtiBd,mBDsiBsB;ECriBtB,2BDqiB8B;EAC9B,aAAA;EACA,YAAA;AA4HF;AA1HE;EANF;IAOI,YAAA;EA6HF;AACF;AArIA;EAUE,4BAAA;EACA,SAAA;EACA,uBAAA;EACA,gCAAA;EACA,uDAAA;EACA,mBAAA;EACA,sDAAA;AA8HF;AA7HE;EACE,SAAA;EACA,UAAA;AA+HJ;AA7HE;EACE,cAAA;EACA,eAAA;ECphBF,oCAAA;EACA,kBAAA;EACA,gBAAA;EDohBE,iBAAA;EACA,WAAA;EACA,kBAAA;AAiIJ;AA/HE;EACE,WAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;ECxiBF,uCAAA;EACA,kBAAA;EDyiBE,yCAAA;EACA,kBAAA;AAkIJ;AAhIE;EC7kBA,aAAA;EACA,mBAFsB;EAGtB,mBAHyC;EAIzC,uBAJmE;EDglBjE,WAAA;EACA,SAAA;AAqIJ;AAnII;EACE,YAAA;AAqIN;AC/iBE;EDyaE;IAGI,WAAA;EAuIN;AACF;AApIE;EACE,yBAAA;EACA,kBAAA;EACA,qBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,+BAAA;EACA,eAAA;ECvVF,2BAAA;EACA,yBAAA;EACA,wBAAA;EACA,sBAAA;EACA,qBAAA;EACA,iBAAA;EACA,wCAAA;AD8dF;AA1IE;EACE,yBAAA;EACA,kBAAA;EACA,qBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,SAAA;AA4IJ;;AAxIA;EC/mBE,aAAA;EACA,sBD+mBc;EC9mBd,mBAHyC;EAIzC,uBAJmE;AD+vBrE;AA7IE;ECjnBA,aAAA;EACA,sBDinBgB;EChnBhB,uBDgnBwB;EC/mBxB,2BD+mBoC;EAClC,SAAA;EACA,eAAA;AAkJJ;AAjJI;ECrnBF,aAAA;EACA,mBDqnBkB;ECpnBlB,uBDonBuB;ECnnBvB,2BDmnBmC;EAC/B,SAAA;EACA,eAAA;AAsJN;AArJM;EACE,YAAA;EACA,YAAA;AAuJR;AAnJE;EACE,YAAA;EACA,YAAA;AAqJJ;AAnJE;EACE,2CAAA;EC3lBF,oCAAA;EACA,kBAAA;EACA,gBAAA;ED2lBE,eAAA;EACA,iBAAA;EACA,SAAA;AAuJJ;AArJE;EACE,SAAA;EACA,gBAAA;EACA,yCAAA;EC7mBF,uCAAA;EACA,kBAAA;ED8mBE,eAAA;EACA,iBAAA;AAwJJ;ACzsBE;EDojBE;IACE,eAAA;EAwJJ;EAtJE;IACE,eAAA;EAwJJ;AACF","sourcesContent":["@use './mixins' as *;\n\n* {\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n.full-height {\n  height: calc(100vh - 90px);\n}\np {\n  margin: 0;\n  padding: 0;\n}\n// .slider-container {\n//   overflow: hidden;\n//   position: relative;\n// }\n.bounceInRight {\n  -webkit-animation-name: bounceInRight;\n  animation-name: bounceInRight;\n}\n.custom-loader {\n  position: relative;\n  height: 100%;\n  width: 100%;\n  pointer-events: none;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 10;\n}\n.icon-filled {\n  font-variation-settings: 'FILL' 1, 'wght' 400, 'GRAD' 0, 'opsz' 48;\n}\n.no-pointer {\n  cursor: not-allowed !important;\n}\n.zoom-join-button-text {\n  @include SemiSans;\n  cursor: pointer;\n}\n.Course-card-header-program-name-text {\n  @include MediumSans;\n  color: #333b48;\n  text-transform: capitalize;\n  text-overflow: ellipsis;\n  white-space: normal;\n  font-size: 16px;\n}\n.Course-card-header {\n  @media (max-width: 769px) {\n    display: flex !important;\n    flex-wrap: wrap !important;\n    .Course-card-header-program-name-text {\n      font-size: 14px;\n    }\n    .course-card-img {\n      width: 70px;\n    }\n\n    .Course-card-header-middle-column {\n      flex-grow: 1;\n    }\n    .Course-card-header-program-name {\n      max-width: auto !important;\n    }\n  }\n}\n.d-none {\n  display: none !important;\n}\n.d-block {\n  display: block !important;\n}\n.d-flex {\n  display: flex !important;\n}\n.w-100 {\n  width: 100% !important;\n}\n.h-100 {\n  height: 100% !important;\n}\n.vh-100 {\n  height: 100vh !important;\n}\n.vw-100 {\n  width: 100vw !important;\n}\n\n/* Flexbox Utilities */\n.flex-row {\n  flex-direction: row !important;\n}\n.flex-column {\n  flex-direction: column !important;\n}\n.flex-row-reverse {\n  flex-direction: row-reverse !important;\n}\n.flex-column-reverse {\n  flex-direction: column-reverse !important;\n}\n.flex-grow-0 {\n  flex-grow: 0 !important;\n}\n.flex-grow-1 {\n  flex-grow: 1 !important;\n}\n.flex-shrink-0 {\n  flex-shrink: 0 !important;\n}\n.flex-shrink-1 {\n  flex-shrink: 1 !important;\n}\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n.flex-nowrap {\n  flex-wrap: nowrap !important;\n}\n.flex-wrap-reverse {\n  flex-wrap: wrap-reverse !important;\n}\n.justify-content-start {\n  justify-content: flex-start !important;\n}\n.justify-content-end {\n  justify-content: flex-end !important;\n}\n.justify-content-center {\n  justify-content: center !important;\n}\n.justify-content-between {\n  justify-content: space-between !important;\n}\n.justify-content-around {\n  justify-content: space-around !important;\n}\n.justify-content-evenly {\n  justify-content: space-evenly !important;\n}\n.align-items-start {\n  align-items: flex-start !important;\n}\n.align-items-end {\n  align-items: flex-end !important;\n}\n.align-items-center {\n  align-items: center !important;\n}\n.align-items-baseline {\n  align-items: baseline !important;\n}\n.align-items-stretch {\n  align-items: stretch !important;\n}\n.align-content-start {\n  align-content: flex-start !important;\n}\n.align-content-end {\n  align-content: flex-end !important;\n}\n.align-content-center {\n  align-content: center !important;\n}\n.align-content-between {\n  align-content: space-between !important;\n}\n.align-content-around {\n  align-content: space-around !important;\n}\n.align-content-stretch {\n  align-content: stretch !important;\n}\n.align-self-auto {\n  align-self: auto !important;\n}\n.align-self-start {\n  align-self: flex-start !important;\n}\n.align-self-end {\n  align-self: flex-end !important;\n}\n.align-self-center {\n  align-self: center !important;\n}\n.align-self-baseline {\n  align-self: baseline !important;\n}\n.align-self-stretch {\n  align-self: stretch !important;\n}\n\n/* Margin and Padding Utilities */\n.m-0 {\n  margin: 0 !important;\n}\n.m-1 {\n  margin: 0.25rem !important;\n}\n.m-2 {\n  margin: 0.5rem !important;\n}\n.m-3 {\n  margin: 1rem !important;\n}\n.m-4 {\n  margin: 1.5rem !important;\n}\n.m-5 {\n  margin: 3rem !important;\n}\n.m-auto {\n  margin: auto !important;\n}\n/* Other margin classes omitted for brevity */\n\n.p-0 {\n  padding: 0 !important;\n}\n.p-1 {\n  padding: 0.25rem !important;\n}\n.p-2 {\n  padding: 0.5rem !important;\n}\n.p-3 {\n  padding: 1rem !important;\n}\n.p-4 {\n  padding: 1.5rem !important;\n}\n.p-5 {\n  padding: 3rem !important;\n}\n/* Other padding classes omitted for brevity */\n\n/* Display Utilities */\n.d-inline {\n  display: inline !important;\n}\n.d-inline-block {\n  display: inline-block !important;\n}\n.d-block {\n  display: block !important;\n}\n\n.d-table {\n  display: table !important;\n}\n.d-table-row {\n  display: table-row !important;\n}\n.d-flex {\n  display: flex !important;\n}\n.d-inline-flex {\n  display: inline-flex !important;\n}\n.d-none {\n  display: none !important;\n}\n\n.h-auto {\n  height: auto !important;\n}\n.w-auto {\n  width: auto !important;\n}\np {\n  margin-bottom: 1rem;\n}\n/* Padding Top */\n.pt-0 {\n  padding-top: 0 !important;\n}\n.pt-1 {\n  padding-top: 0.25rem !important;\n}\n.pt-2 {\n  padding-top: 0.5rem !important;\n}\n.pt-3 {\n  padding-top: 1rem !important;\n}\n.pt-4 {\n  padding-top: 1.5rem !important;\n}\n.pt-5 {\n  padding-top: 3rem !important;\n}\n\n/* Padding Left */\n.pl-0 {\n  padding-left: 0 !important;\n}\n.pl-1 {\n  padding-left: 0.25rem !important;\n}\n.pl-2 {\n  padding-left: 0.5rem !important;\n}\n.pl-3 {\n  padding-left: 1rem !important;\n}\n.pl-4 {\n  padding-left: 1.5rem !important;\n}\n.pl-5 {\n  padding-left: 3rem !important;\n}\n\n/* Padding Bottom */\n.pb-0 {\n  padding-bottom: 0 !important;\n}\n.pb-1 {\n  padding-bottom: 0.25rem !important;\n}\n.pb-2 {\n  padding-bottom: 0.5rem !important;\n}\n.pb-3 {\n  padding-bottom: 1rem !important;\n}\n.pb-4 {\n  padding-bottom: 1.5rem !important;\n}\n.pb-5 {\n  padding-bottom: 3rem !important;\n}\n\n/* Padding Right */\n.pr-0 {\n  padding-right: 0 !important;\n}\n.pr-1 {\n  padding-right: 0.25rem !important;\n}\n.pr-2 {\n  padding-right: 0.5rem !important;\n}\n.pr-3 {\n  padding-right: 1rem !important;\n}\n.pr-4 {\n  padding-right: 1.5rem !important;\n}\n.pr-5 {\n  padding-right: 3rem !important;\n}\n\n/* Margin Top */\n.mt-0 {\n  margin-top: 0 !important;\n}\n.mt-1 {\n  margin-top: 0.25rem !important;\n}\n.mt-2 {\n  margin-top: 0.5rem !important;\n}\n.mt-3 {\n  margin-top: 1rem !important;\n}\n.mt-4 {\n  margin-top: 1.5rem !important;\n}\n.mt-5 {\n  margin-top: 3rem !important;\n}\n\n/* Margin Bottom */\n.mb-0 {\n  margin-bottom: 0 !important;\n}\n.mb-1 {\n  margin-bottom: 0.25rem !important;\n}\n.mb-2 {\n  margin-bottom: 0.5rem !important;\n}\n.mb-3 {\n  margin-bottom: 1rem !important;\n}\n.mb-4 {\n  margin-bottom: 1.5rem !important;\n}\n.mb-5 {\n  margin-bottom: 3rem !important;\n}\n\n/* Margin Left */\n.ml-0 {\n  margin-left: 0 !important;\n}\n.ml-1 {\n  margin-left: 0.25rem !important;\n}\n.ml-2 {\n  margin-left: 0.5rem !important;\n}\n.ml-3 {\n  margin-left: 1rem !important;\n}\n.ml-4 {\n  margin-left: 1.5rem !important;\n}\n.ml-5 {\n  margin-left: 3rem !important;\n}\n\n/* Margin Right */\n.mr-0 {\n  margin-right: 0 !important;\n}\n.mr-1 {\n  margin-right: 0.25rem !important;\n}\n.mr-2 {\n  margin-right: 0.5rem !important;\n}\n.mr-3 {\n  margin-right: 1rem !important;\n}\n.mr-4 {\n  margin-right: 1.5rem !important;\n}\n.mr-5 {\n  margin-right: 3rem !important;\n}\n\nh1 {\n  margin-top: 0;\n  margin-bottom: 0.5rem;\n  font-weight: 500;\n  line-height: 1.2;\n}\n\nh2 {\n  margin-top: 0;\n  margin-bottom: 0.5rem;\n  font-weight: 500;\n  line-height: 1.2;\n}\n\nh3 {\n  margin-top: 0;\n  margin-bottom: 0.5rem;\n  font-weight: 500;\n  line-height: 1.2;\n}\n\nh4 {\n  margin-top: 0;\n  margin-bottom: 0.5rem;\n  font-weight: 500;\n  line-height: 1.2;\n}\n\nh5 {\n  margin-top: 0;\n  margin-bottom: 0.5rem;\n  font-weight: 500;\n  line-height: 1.2;\n}\n\nh6 {\n  margin-top: 0;\n  margin-bottom: 0.5rem;\n  font-weight: 500;\n  line-height: 1.2;\n}\np {\n  margin: 0;\n  padding: 0;\n}\n\n.slick-dots .slick-active .customDots {\n  width: 28px !important;\n  background: #5095fc !important;\n}\n.slick-dots {\n  bottom: -16px !important;\n  li {\n    margin: 0 8px !important;\n    width: fit-content !important;\n    height: fit-content !important;\n  }\n  li:first-child {\n    margin-right: 0px !important;\n  }\n}\n.zoom-mobile-view {\n  height: 100vh;\n  width: 100vw;\n  @include flex(column);\n  overflow: hidden;\n  background: linear-gradient(249deg, #c2d5ff 26%, #d7fff8 73.92%);\n  &-img {\n    @include flex();\n    padding: 16px;\n  }\n}\n.zoom-trying-img {\n  width: 100%;\n\n  @supports (-webkit-touch-callout: none) {\n    height: calc(100vh - 450px);\n    object-fit: contain;\n  }\n  height: calc(100vh - 420px);\n  // object-fit: contain;\n  // @media screen and (min-height: 850px) {\n  //   height: calc(100vh - 420px);\n  //   height: calc(100svh - 420px);\n  // }\n  @media screen and (min-height: 730px) {\n    height: 45vh;\n    padding-top: 60px;\n    // height: calc(100svh - 450px);\n  }\n  @media screen and (min-height: 850px) {\n    height: 45vh;\n    padding-top: 80px;\n    // height: calc(100svh - 450px);\n  }\n}\n.zoom-mobile-img {\n  flex-grow: 1;\n  @include flex(column, center, flex-start);\n  // margin-top: 18px;\n  .zoom-background-img {\n    width: 100%;\n    height: 100%;\n    background-repeat: no-repeat;\n    background-position: top;\n    background-size: cover;\n  }\n}\n\n.zoom-mobile-bottom-container {\n  flex-grow: 1;\n  @include flex(column, center, flex-start);\n  height: 320px;\n  width: 100vw;\n\n  @media screen and (min-height: 820px) {\n    height: 42vh;\n    // justify-content: space-between;\n  }\n  padding: 28px 16px 24px 16px;\n  gap: 24px;\n  background-color: white;\n  border-radius: 30px 30px 0px 0px;\n  border: 2px solid var(--Color-Surface-Primary, #fdfdfd);\n  background: #f0f4ff;\n  box-shadow: 0px -4px 16px 0px rgba(147, 172, 214, 0.3);\n  p {\n    margin: 0;\n    padding: 0;\n  }\n  .zoom-mobile-heading {\n    color: #5095fc;\n    font-size: 20px;\n    @include SemiSans;\n    line-height: 125%;\n    width: 100%;\n    text-align: center;\n  }\n  .zoom-mobile-subHeading {\n    color: #000;\n    text-align: center;\n    font-size: 14px;\n    line-height: 150%;\n    margin-top: 12px;\n    @include RegularSans;\n    color: var(--Color-Text-Primary, #333b48);\n    text-align: center;\n  }\n  .app-store-button {\n    @include flex();\n    width: 100%;\n    gap: 16px;\n\n    img {\n      width: 167px;\n      @include m_mobile {\n        width: 40vw;\n      }\n    }\n  }\n  .continue-browser {\n    color: rgba(0, 0, 0, 0.6);\n    text-align: center;\n    font-family: 'Roboto';\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 600;\n    text-decoration-line: underline;\n    cursor: pointer;\n    @include remove_userTapColor;\n  }\n  .or-button {\n    color: rgba(0, 0, 0, 0.5);\n    text-align: center;\n    font-family: 'Roboto';\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 150%; /* 18px */\n  }\n}\n\n.left-short-img {\n  @include flex(column);\n  .left-short-img-container {\n    @include flex(column, flex-start, flex-start);\n    gap: 24px;\n    padding: 0 40px;\n    .app-store-button {\n      @include flex(row, flex-start, flex-start);\n      gap: 16px;\n      flex-wrap: wrap;\n      img {\n        width: 160px;\n        height: 52px;\n      }\n    }\n  }\n  img {\n    width: 192px;\n    height: 34px;\n  }\n  h6 {\n    color: var(--Color-Accent-Shade-1, #5095fc);\n    @include SemiSans;\n    font-size: 32px;\n    line-height: 125%;\n    margin: 0;\n  }\n  p {\n    margin: 0;\n    margin-top: 12px;\n    color: var(--Color-Text-Primary, #333b48);\n    @include RegularSans;\n    font-size: 18px;\n    line-height: 150%;\n  }\n  @include respond-to(765px) {\n    h6 {\n      font-size: 24px;\n    }\n    p {\n      font-size: 16px;\n    }\n  }\n}\n","@mixin flex($direction: row, $align-items: center, $justify-content: center) {\n  display: flex;\n  flex-direction: $direction;\n  align-items: $align-items;\n  justify-content: $justify-content;\n}\n\n@mixin container {\n  margin: auto;\n  max-width: 1920px;\n}\n\n@mixin s_container {\n  max-width: 1536px;\n  margin: 0 auto;\n  padding: 0 32px;\n\n  @include l_desktop {\n    max-width: 1320px;\n  }\n\n  @include s_tablet {\n    padding: 0 16px;\n  }\n}\n\n@mixin box($width, $height: $width) {\n  width: $width;\n  height: $height;\n}\n\n// FONT ISSUE NOT MATCHING NEED TO GRAB NEW FONTS\n@mixin RegularSans {\n  font-family: 'Regular Sans', sans-serif;\n  font-style: normal;\n}\n@mixin MediumSans {\n  font-family: 'Medium Sans', sans-serif;\n  font-style: normal;\n  font-weight: 500;\n}\n@mixin SemiSans {\n  font-family: 'Semi Sans', sans-serif;\n  font-style: normal;\n  font-weight: 600;\n}\n@mixin BoldSans {\n  font-family: 'Bold Sans', sans-serif;\n  font-style: normal;\n  font-weight: 700;\n}\n\n@mixin auth-heading {\n  @include Playfair;\n  line-height: 1.875rem;\n  font-weight: 600;\n  letter-spacing: -3%;\n  font-size: 2rem;\n  @include s_tablet {\n    font-size: 1.8rem;\n  }\n}\n\n@mixin auth-subheading {\n  @include Inter;\n  line-height: 1.875rem;\n  font-weight: 400;\n  font-size: 1rem;\n  @include s_tablet {\n    font-size: 0.9rem;\n  }\n}\n@mixin validation-text {\n  color: #ff0000;\n  font-size: 0.875rem;\n}\n\n@mixin input-placeholder {\n  &.placeholder {\n    @content;\n  }\n  &:-moz-placeholder {\n    @content;\n  }\n  &::-moz-placeholder {\n    @content;\n  }\n  &:-ms-input-placeholder {\n    @content;\n  }\n  &::-webkit-input-placeholder {\n    @content;\n  }\n}\n\n@mixin respond-to($max-width) {\n  @media (max-width: $max-width) {\n    @content;\n  }\n}\n@mixin respond-to-min($max-width) {\n  @media (min-width: $max-width) {\n    @content;\n  }\n}\n\n@mixin respond-to-height($max-height) {\n  @media (max-height: $max-height) {\n    @content;\n  }\n}\n\n@mixin larger_desktop {\n  @media (min-width: 1920px) {\n    @content;\n  }\n}\n@mixin l_desktop {\n  @media (min-width: 1536px) {\n    @content;\n  }\n}\n\n@mixin sm_desktop {\n  @media (max-width: 1350px) {\n    @content;\n  }\n}\n\n@mixin m_desktop {\n  @media (max-width: 1199px) {\n    @content;\n  }\n}\n\n@mixin s_desktop {\n  @media (max-width: 1024px) {\n    @content;\n  }\n}\n\n@mixin l_tablet {\n  @media (max-width: 991px) {\n    @content;\n  }\n}\n\n@mixin m_tablet {\n  @media (max-width: 768px) {\n    @content;\n  }\n}\n\n@mixin sm_tablet {\n  @media (min-width: 601px) and (max-width: 768px) {\n    @content;\n  }\n}\n\n@mixin s_tablet {\n  @media (max-width: 550px) {\n    @content;\n  }\n}\n@mixin l_mobile {\n  @media (max-width: 425px) {\n    @content;\n  }\n}\n@mixin m_mobile {\n  @media (max-width: 375px) {\n    @content;\n  }\n}\n@mixin s_mobile {\n  @media (max-width: 350px) {\n    @content;\n  }\n}\n@mixin xs_mobile {\n  @media (max-width: 300px) {\n    @content;\n  }\n}\n@mixin safari_specific_style {\n  @supports (-webkit-touch-callout: none) {\n    @content;\n  }\n}\n@mixin hide_scrollbar {\n  /* Hide scrollbar for Chrome, Safari and Opera */\n  &::-webkit-scrollbar {\n    display: none;\n  }\n\n  /* Hide scrollbar for IE, Edge and Firefox */\n  & {\n    -ms-overflow-style: none; /* IE and Edge */\n    scrollbar-width: none; /* Firefox */\n  }\n}\n\n@mixin underline_animation {\n  overflow: hidden;\n  background: linear-gradient(currentColor 0 0) 0 100% / var(--d, 0) 1px\n    no-repeat;\n  transition: 0.5s;\n  &:hover {\n    --d: 100%;\n  }\n}\n\n@mixin bounceInRight($duration: 0.5s) {\n  @-webkit-keyframes bounceInRight {\n    0% {\n      opacity: 0;\n      -webkit-transform: translateX(2000px);\n    }\n    100% {\n      -webkit-transform: translateX(0);\n    }\n  }\n  -webkit-animation-duration: $duration;\n  animation-duration: $duration;\n  -webkit-animation-fill-mode: both;\n  animation-fill-mode: both;\n  @keyframes bounceInRight {\n    0% {\n      opacity: 0;\n      -webkit-transform: translateX(2000px);\n    }\n    100% {\n      -webkit-transform: translateX(0);\n    }\n  }\n}\n\n@mixin bounceOutRight($duration: 0.5s) {\n  @-webkit-keyframes bounceOutRight {\n    20% {\n      opacity: 1;\n      -webkit-transform: translateX(-10px);\n    }\n    100% {\n      opacity: 0;\n      -webkit-transform: translateX(2000px);\n    }\n  }\n\n  @keyframes bounceOutRight {\n    20% {\n      opacity: 1;\n      transform: translateX(-10px);\n    }\n    100% {\n      opacity: 0;\n      transform: translateX(2000px);\n    }\n  }\n\n  -webkit-animation-duration: $duration;\n  animation-duration: $duration;\n  -webkit-animation-fill-mode: both;\n  animation-fill-mode: both;\n}\n\n@mixin remove_userTapColor {\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  -khtml-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  -webkit-tap-highlight-color: transparent;\n}\n\n@mixin ellipsis($line: 4) {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-line-clamp: $line; /* Set the number of lines to be shown */\n  -webkit-box-orient: vertical;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
